(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  const setupShare = () => {
    document.querySelectorAll('[data-anm-share]').forEach((button) => {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      button.addEventListener('click', async () => {
        const title = button.dataset.title || document.title;
        const url = button.dataset.url || window.location.href.split('?')[0];
        try {
          if (navigator.share) await navigator.share({ title, url });
          else {
            await navigator.clipboard.writeText(url);
            const original = button.textContent;
            button.textContent = 'Link copied';
            window.setTimeout(() => { button.textContent = original; }, 1800);
          }
        } catch (error) {
          if (error?.name !== 'AbortError') button.textContent = 'Unable to share';
        }
      });
    });
  };

  const setupFaq = () => {
    document.querySelectorAll('[data-anm-faq]').forEach((group) => {
      group.addEventListener('toggle', (event) => {
        const current = event.target;
        if (!(current instanceof HTMLDetailsElement) || !current.open) return;
        group.querySelectorAll('details[open]').forEach((details) => {
          if (details !== current) details.open = false;
        });
      }, true);
    });
  };

  const setupCartMessage = async () => {
    const hosts = document.querySelectorAll('[data-anm-cart-status]');
    if (!hosts.length) return;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
      const quantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
      let message = '';
      if (quantity === 1) message = '67 Launch: $6.70 per squishy. Add one more to save 10%.';
      else if (quantity === 2) message = '67 Launch: Your 10% bundle savings apply. Add one more for 15%.';
      else if (quantity >= 3) message = '67 Launch: Your 15% bundle savings apply.';
      hosts.forEach((host) => { host.textContent = message; host.hidden = !message; });
    } catch (_) {
      hosts.forEach((host) => { host.hidden = true; });
    }
  };

  const getProductLinks = () => {
    const source = document.getElementById('AnmProductLinks');
    if (!source) return {};
    try {
      return JSON.parse(source.textContent || '{}');
    } catch (_) {
      return {};
    }
  };

  const setupJudgeMeCarousel = () => {
    const productLinks = getProductLinks();
    document.querySelectorAll('.jdgm-carousel-wrapper').forEach((wrapper) => {
      const title = wrapper.querySelector('.jdgm-carousel-title');
      if (title && title.textContent.trim() !== 'What customers are saying') title.textContent = 'What customers are saying';

      // Judge.me's aggregate count can lag after reviews are unpublished. The
      // carousel items are the eligible, customer-facing records Judge.me has
      // actually rendered, so use that live set for the heading and keep it in
      // sync through the observer below.
      const items = Array.from(wrapper.querySelectorAll('.jdgm-carousel-item'));

      const count = wrapper.querySelector('.jdgm-carousel-number-of-reviews');
      if (count) {
        const reportedTotal = Number.parseInt(count.dataset.numberOfReviews || '0', 10);
        const total = items.length || reportedTotal;
        const countText = `From ${total} ${total === 1 ? 'Review' : 'Reviews'}`;
        if (count.textContent.trim() !== countText) count.textContent = countText;
        count.dataset.numberOfReviews = String(total);
        count.classList.remove('jdgm-carousel-number-of-reviews--verified');
      }

      wrapper.dataset.anmReviewCount = String(items.length);
      items.forEach((item) => {
        if (item.dataset.anmProductLinked === 'true') return;
        const product = item.querySelector('.jdgm-carousel-item__product');
        const image = item.querySelector('.jdgm-carousel-item__product-image');
        const productName = image?.alt?.trim();
        const productUrl = productName ? productLinks[productName] : '';
        if (!product || !image || !productName || !productUrl) return;

        if (!image.closest('a')) {
          const imageLink = document.createElement('a');
          imageLink.className = 'jdgm-carousel-item__product-image-link';
          imageLink.href = productUrl;
          imageLink.setAttribute('aria-label', `View ${productName}`);
          image.parentNode.insertBefore(imageLink, image);
          imageLink.appendChild(image);
        }

        if (!product.querySelector('.jdgm-carousel-item__product-name')) {
          const nameLink = document.createElement('a');
          nameLink.className = 'jdgm-carousel-item__product-name';
          nameLink.href = productUrl;
          nameLink.textContent = productName;
          product.appendChild(nameLink);
        }
        item.dataset.anmProductLinked = 'true';
      });
    });
  };

  onReady(() => {
    setupShare();
    setupFaq();
    setupCartMessage();
    setupJudgeMeCarousel();
    const judgeMeObserver = new MutationObserver(setupJudgeMeCarousel);
    judgeMeObserver.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => {
      setupShare();
      setupFaq();
      setupCartMessage();
      setupJudgeMeCarousel();
    });
    document.addEventListener('cart:update', setupCartMessage);
  });
})();



